import React from 'react';
import { connect } from 'react-redux';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose } from 'ramda';

import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField.jsx';

import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { RichText, Button } from '@synergycms_core/components/generic/';
import ConditionsModal from '../../CustomerForm/ConditionsModal';





//const iscorporate = store.getIn(['customer', 'corporate', 'tipo_perfil'], false) === '1'

const LoyaltyPoliciesChecks = class LoyaltyPoliciesChecks extends React.Component {
  static displayName = 'LoyaltyPoliciesChecks';
  constructor(props){
    super(props);
    this.state = {
      visible:false
    }
  }
  visibleGDPR = (e) => {
    this.setState((state)=>{
      return {
        visible:true
      };
  });
  };

  render() {
    const { config } = this.props;
    const {reservation, classes } = config;
    
    return (<>
      <label className={[classes.checkBox, classes.oblig].join(' ')} ref={'check_loyalty'}>
        <CheckboxField
          defaultValue={reservation.getIn(['customer', 'check_loyalty'], false)}
          type={'checkbox'}
          validations={["required"]}
          validationsFields={{ field: '' }}
          model={'check_loyalty'}
          innerStyle={['inputCheck', classes.inputCheck]}
          css={{ invalid: null, valid: null }}
          ariaLabel={'_%aceptar politica%_'}
        />
        <RichText
          translate={true}
          ucFirst={true}
          text={'_%deseo formar parte del programa de fidelidad Star Traveler de Eurostars Hotel Company, de conformidad con lo dispuesto en los%_'}
        />{' '}
        <label ref={''}>
        <ConditionsModal modalTitle={'_%términos y Condiciones del programa%_'} modalText={'_%loyalty_terms%_'} ucFirst={true} isStarTraveler={true}/>{' '}
        </label>
        <RichText
        translate={true}
          text={'_%y en la%_'}
        />{' '}
        <label ref={''}>
        <ConditionsModal modalTitle={'_%política de Privacidad%_'} modalText={'_%data_protection%_'} ucFirst={true} isStarTraveler={true}/>
        </label>
        <RichText
        translate={true}
          text={'_%. si no quieres recibir información comercial, haz clic%_'}
          ucFirst={true}
        />{' '}
        <Button
          onClick={this.visibleGDPR}
          richText={{ translate: true, text: '_%aquí%_' }}
          innerStyle={[classes.refuseInfoBtn]}
        />
        <RichText
          text={'.'}
          translate={false}
        />{' '}
        <InputNotify model={'check_loyalty'} css={{ valid: null }}/>
      </label>
     {(this.state.visible || reservation.getIn(['customer', 'GDPR_loyalty'])) && <label className={classes.checkBox}>
        <CheckboxField
          defaultValue={reservation.getIn(['customer', 'GDPR_loyalty'], false)}
          type={'checkbox'}
          model={'GDPR_loyalty'}
          innerStyle={['inputCheck', classes.inputCheck]}
        />
        <RichText translate={true} ucFirst={true} innerStyle={['GDPR_loyalty']} text={'_%Prefiero no recibir futuras comunicaciones vinculadas a promociones especiales y ofertas exclusivas vinculadas al programa de fidelización.%_'} />
      </label>}
    </>)
  };
};


const mapStateToProps = (store) => {

  return {    
    loyaltyUser: store.getIn(['customer', 'loyalty','user',"user_id"], null) && store.getIn(['customer', 'loyalty','user'], null)
  };
};

export default compose(
  //validateAsyncComponent(mapStateToProps),
  connect(mapStateToProps),
  //withThemeJSS(),
  PropertyManager([
    "classes", "isStarTraveler", "loyaltyUser", "loyaltySelected", "profileType", "reservation","hotel", "penalties", "requiredPrepaymentText"
  ]),
  withContent('links')
)(LoyaltyPoliciesChecks);
